export class ArchiveConfiguration {
    constructor(private container: JQuery) {
        const baseUrl = container.attr('data-api-root-prefix');
    }
}
